<style>
@import url(./assets/global/plugins/font-awesome/css/font-awesome.css);
@import url(./assets/global/plugins/simple-line-icons/simple-line-icons.css);
@import url(./assets/global/plugins/bootstrap/css/bootstrap.css);
@import url(./assets/global/plugins/bootstrap-switch/css/bootstrap-switch.css);
@import url(./assets/global/css/components-rounded.css);
@import url(./assets/global/css/plugins.css);
@import url(./assets/layouts/layout3/css/layout.css);
@import url(./assets/layouts/layout3/css/themes/default.css);
@import url(./assets/layouts/layout3/css/custom.css);
</style>

<template>
  <div>
    <div class="page-wrapper">
      <PageHeader :profile="this.profile" v-if="this.isAuthenticated"></PageHeader>
      <div class="page-wrapper-row full-height">
        <div class="page-wrapper-middle">
          <div class="page-container">
            <div class="page-content-wrapper">
              <router-view name="pageHeader"></router-view>
              <div class="page-content">
                <div class="container-fluid">
                  <div class="page-content-inner">
                    <router-view name="pageContent" :profile="this.profile" :jira="this.jira"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PageFooter v-if="this.isAuthenticated"></PageFooter>
    </div>
  </div>
</template>

<script>
import PageHeader from "./components/Layout/PageHeader";
import PageFooter from "./components/Layout/PageFooter";
import Login from "./components/Page/Login";
import Jira from "./jira.js";

export default {
  components: { PageHeader, PageFooter, Login, Jira },
  async created() {
    try {
      await this.$auth.renewTokens();
    } catch {
      // Supress the 'not logged in' error as we can illegitimately get that
      // when processing the callback url
    }
  },
  methods: {
    login() {
      this.$auth.login();
    },
    logout() {
      this.$auth.logOut();
      this.$router.push({ path: "/" });
    },
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn;
      this.profile = data.profile;
    }
  },
  data() {
    return {
      isAuthenticated: false,
      profile: {},
      jira: Jira
    };
  }
};
</script>
